import script from "./PageTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./PageTemplate.vue?vue&type=style&index=0&id=d7c0fa08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7c0fa08"]])

export default __exports__